import { useQuery } from "react-query";
import { useAccessToken } from "hooks/useAccessToken";
import { QUERY_STALE_TIME } from "utils/constants";
import queryFn from "ApiLayer/Reports/Baseline/queryBuildingBarChartAndMap";

export const useBuildingBarChartAndMap = (filtersetUid: string | null) => {
    const accessToken = useAccessToken();

    return useQuery({
        queryKey: ["buildingBarChartAndMap", filtersetUid],
        queryFn: async () =>
            queryFn(accessToken, {
                reportFiltersetUid: filtersetUid,
            }),
        staleTime: QUERY_STALE_TIME,
        enabled: !!filtersetUid,
    });
};
